import { render } from "./home-group.vue?vue&type=template&id=456f0b76"
import script from "./home-group.vue?vue&type=script&lang=js"
export * from "./home-group.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__